import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { useUIDSeed } from 'react-uid';
import { Fieldset } from '../fieldset';
import { textarea as textareaClass, textareaContainer as textareaContainerClass } from './textarea.module.css';
export const Textarea = forwardRef(({ className, invalid, dimension, disabled, label, errorMessage, ...props }, forwardedRef) => {
    const uid = useUIDSeed();
    const fieldsetProps = {
        invalid,
        label,
        disabled,
        dimension,
        errorMessage
    };
    const inputProps = {
        disabled
    };
    return (React.createElement(Fieldset, { className: clsx(textareaContainerClass, className), htmlFor: uid('field'), ...fieldsetProps },
        React.createElement("textarea", { className: textareaClass, ref: forwardedRef, ...inputProps, ...props, id: uid('field') })));
});
Textarea.displayName = 'Textarea';
